// The ONE notice store. Every transient message in the app (saved, checked
// out, a failed save, a progress line) goes through here and is drawn by the
// single <NoticeHost /> mounted in App: centred under the header, on the
// theme's panel surface. There used to be five separate systems (the toast
// stack, the viewer's save toast, the canvas's save toast, the doc-property
// error banner, the Admin page's corner message), most of them black cards in
// the bottom-right corner whatever the theme.
//
//   showNotice({ kind, title, detail, actions, duration, id, onDismiss }) -> id
//   dismissNotice(id)
//
// kind: 'success' | 'info' | 'warning' | 'error' | 'progress'. An error stays
// until it is closed; a success leaves after 2.5 s, info after 4 s, a warning
// after 6 s; progress stays until its owner removes it. Passing an `id` that
// is already showing REPLACES that notice in place (used by live notices).

const DEFAULT_MS = { success: 2500, info: 4000, warning: 6000, error: 0, progress: 0 };

let notices = [];
const listeners = new Set();
const timers = new Map();
let seq = 0;

function emit() { for (const fn of listeners) fn(notices); }

export function subscribeNotices(fn) {
  listeners.add(fn);
  fn(notices);
  return () => listeners.delete(fn);
}

export function dismissNotice(id) {
  if (timers.has(id)) { clearTimeout(timers.get(id)); timers.delete(id); }
  const gone = notices.find(n => n.id === id);
  if (!gone) return;
  notices = notices.filter(n => n.id !== id);
  emit();
}

export function showNotice({ id, kind = 'info', title, detail, actions, duration, onDismiss } = {}) {
  const key = id || `n${++seq}`;
  const ms = kind === 'error' || kind === 'progress' ? 0 : (duration ?? DEFAULT_MS[kind] ?? 4000);
  const item = { id: key, kind, title, detail, actions: actions || [], onDismiss };
  const at = notices.findIndex(n => n.id === key);
  notices = at >= 0 ? notices.map((n, i) => (i === at ? item : n)) : [...notices, item];
  if (timers.has(key)) { clearTimeout(timers.get(key)); timers.delete(key); }
  if (ms > 0) timers.set(key, setTimeout(() => dismissNotice(key), ms));
  emit();
  return key;
}
